import { EventCatalogFilters, EventOffersRepository } from '@lib/api/repository/event-offers/event-offers.repository';
import { EventOffersUseCase } from '@lib/interfaces/usecase/event-offers.use-case';

export default class EventOffersService implements EventOffersUseCase {
  constructor(private repository: EventOffersRepository) {}

  cards(eventId: string, filters: EventCatalogFilters, signal?: AbortSignal) {
    return this.repository.cards(eventId, filters, signal);
  }

  products(eventId: string, page: number, signal?: AbortSignal) {
    return this.repository.products(eventId, page, signal);
  }
}
